
import ACTS from '../constants'

const defaultStatus = {
    title: '세금관리'
}

export default (state = defaultStatus, action) => {
    switch(action.type) {
        case ACTS.TAX_SUMMARY:
        return{
            ...state,
            items : action.payload.item
        }        
        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/tax.js